<div class="frame__city__inner" data-frame="1" :class="(dataForm.detailsDropdown ? 'active-result-frame' : 'active-result-frame_show_mobile')">
  <div class="frame__city-top">
      <div class="frame__city__points">
          <div class="city-point"></div>
          <div class="city-point"></div>
      </div>
      <div class="frame__city__cities">
          <div class="frame__city__wrap">
              <div class="frame-city" cityfrom>{{(dataForm.sender.cityFrom) ? dataForm.sender.cityFrom : 'Откуда'}}</div>
              <div class="frame-city-adress">{{dataForm.sender.officeFrom.address}}</div>
          </div>
          <div class="frame__city__wrap">
              <div class="frame-city" cityto>{{(dataForm.consignee.cityTo) ? dataForm.consignee.cityTo : 'Куда'}}</div>
              <div class="frame-city-adress">{{dataForm.consignee.officeTo.address}}</div>
          </div>
      </div>
  </div>
  <div class="frame__data-btn" @click="openWindow()" :class="dataForm.detailsDropdown ? 'btn-open' : ''" ></div>
</div>